import styled, { css } from 'styled-components';

export const StartToModalTitle = styled.p(
    ({ theme: { fontSize, fontWeight } }) => css`
        font-size: ${fontSize['26']}px;
        font-weight: ${fontWeight.normal};
        line-height: 34px;
        margin: 0;
    `,
);

export const StartToModalInner = styled.div`
    display: grid;
    gap: 8px;
    padding: 16px 0 0;
`;
